import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  Input,
  Upload,
  message,
  Select,
  Modal,
  Form,
  Switch,
  Space,
  Row,
  Col,
} from "antd";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { InboxOutlined } from "@ant-design/icons";
import dataService from "../networks/api/service/dataService";
import FullScreenLoader from "../components/FullScreenLoader";
import CustomTable from "../components/TableComponent/CustomTable";

const { Option } = Select;
const { Dragger } = Upload;

const AddVoters = () => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [constituencyList, setconstituencyList] = useState([]);
  const [assemblyList, setassemblyList] = useState([]);
  const [panchayatList, setpanchayatList] = useState([]);
  const [boothList, setboothList] = useState([]);
  const [assemblyId, setassemblyId] = useState("");
  const [panchayatId, setpanchayatId] = useState("");
  const [boothId, setboothId] = useState("");
  const [constituencyId, setconstituencyId] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const handleFileUpload = (info) => {
    setLoading(true);
    if (info.file.status === "done") {
      const file = info.file.originFileObj;
      const isCSV = file.type === "text/csv";
      const isXLSX =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      if (isCSV) {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            const parsedData = result?.data?.map((item, index) => ({
              ...item,
              key: index,
            }));
            setData(parsedData);
            setColumnsFromHeaders(result.meta.fields);
            setLoading(false);

            message.success("CSV file uploaded and data parsed successfully!");
          },
          error: (error) => {
            message.error("Failed to parse CSV file.");
            console.error(error);
          },
        });
      } else if (isXLSX) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const workbook = XLSX.read(e.target.result, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            defval: "",
            header: 1,
          });

          const headers = jsonData[0];
          const rows = jsonData.slice(1)?.map((row, index) => {
            const rowData = headers.reduce((acc, header, i) => {
              acc[header] = row[i] || "";
              return acc;
            }, {});
            return { ...rowData, key: index };
          });

          setData(rows);
          setColumnsFromHeaders(headers);
          setLoading(false);
          message.success("XLSX file uploaded and data parsed successfully!");
        };
        reader.readAsBinaryString(file);
      } else {
        message.error(
          "Unsupported file format. Please upload a CSV or XLSX file."
        );
      }
    }
  };

  const setColumnsFromHeaders = (headers) => {
    const dynamicColumns = headers?.map((header) => ({
      title: header,
      dataIndex: header,
      render: (text, record, rowIndex) => (
        <Input
          value={text}
          onChange={(e) => handleCellChange(e, rowIndex, header)}
        />
      ),
    }));
    setColumns(dynamicColumns);
  };

  const handleCellChange = (e, rowIndex, header) => {
    setData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex][header] = e.target.value;
      return newData;
    });
  };

  // New function to convert edited data to file (CSV or XLSX)
  const generateFileFromData = (data, format = "csv") => {
    if (format === "csv") {
      const csv = Papa.unparse(data);
      const blob = new Blob([csv], { type: "text/csv" });
      return new File([blob], "edited_data.csv", { type: "text/csv" });
    } else if (format === "xlsx") {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const fileBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      return new File([fileBuffer], "edited_data.xlsx", {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    }
  };

  const handleSaveAll = async () => {
    const file = generateFileFromData(data, "csv"); // Generate file from edited data
    const formData = new FormData();
    formData.append("file", file);
    formData.append("assemblyId", assemblyId);
    formData.append("panchayatId", panchayatId);
    formData.append("boothId", boothId);

    try {
      const res = await dataService.AddVoters(formData);
      if (res.code === 200) {
        message.success(res.message);
        setData([]);
      } else {
        message.error("Something went wrong.");
      }
    } catch (e) {
      console.error(e);
      message.error("Failed to upload file.");
    }
  };

  const handleAddVoter = async (values) => {
    console.log(values);

    setLoading(true);
    try {
      const payload = {
        constituencyId,
        assemblyId,
        panchayatId,
        boothId,
        ...values,
      };
      const res = await dataService.AddVoter(payload);
      if (res.code === 200) {
        message.success("Voter added successfully!");
        setIsModalVisible(false);
        form.resetFields();
        // Optionally refresh data here
      } else {
        message.error("Failed to add voter.");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while adding the voter.");
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
    console.log("Modal should now be visible");
  };

  const hideModal = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const OnBoothSelect = (value) => setboothId(value);
  const OnAssemblySelect = async (value) => {
    setassemblyId(value);
    setpanchayatId("");
    setboothId("");
    setboothList([]);
    setpanchayatList([]);
    try {
      const res = await dataService.getPanchayatFromAssembly({
        assembly: value,
      });
      if (res.code === 200) setpanchayatList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnPanchayatSelect = async (value) => {
    setpanchayatId(value);
    setboothId("");
    setboothList([]);
    try {
      const res = await dataService.GetBooth({ panchayat: value });
      if (res.code === 200) setboothList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const OnConstituencySelect = async (value) => {
    setconstituencyId(value);
    setassemblyId("");
    setpanchayatId("");
    setboothId("");
    setassemblyList([]);
    setboothList([]);
    setpanchayatList([]);
    try {
      const res = await dataService.getAssemblyFromConstituency(value);
      if (res.code === 200) setassemblyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setconstituencyList([res.data[1]]);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getConstituency();
  }, []);

  return (
    <div>
      {loading && <FullScreenLoader />}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2>Add Voters</h2>
        <Button
          type="primary"
          style={{ marginTop: 20, marginBottom: 20 }}
          onClick={showModal}
        >
          Add Voter
        </Button>
      </div>

      <div
        style={{
          marginBottom: 40,
          display: "flex",
          flexWrap: "wrap", // Enable wrapping on smaller screens
          gap: "10px", // Add spacing between elements
        }}
      >
        <Select
          value={constituencyId}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option?.children;
            return String(children).toLowerCase().includes(input.toLowerCase());
          }}
          placeholder="Select Parliament"
          style={{
            minWidth: "150px",
            flex: "1",
            marginBottom: "10px",
            border: "1px solid grey",
            borderRadius: 5,
          }}
          onChange={OnConstituencySelect}
        >
          <Option key={827272} value="" disabled>
            Select Parliament
          </Option>
          {constituencyList?.map((item) => (
            <Option key={item?._id} value={item?._id}>
              {item?.constituencyName}
            </Option>
          ))}
        </Select>

        <Select
          value={assemblyId}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option?.children;
            return String(children).toLowerCase().includes(input.toLowerCase());
          }}
          placeholder="Select Assembly"
          style={{
            minWidth: "150px",
            flex: "1",
            marginBottom: "10px",
            border: "1px solid grey",
            borderRadius: 5,
          }}
          onChange={OnAssemblySelect}
        >
          <Option key={827272} value="" disabled>
            Select Assembly
          </Option>
          {assemblyList?.map((item) => (
            <Option key={item?._id} value={item?._id}>
              {item.assemblyName}
            </Option>
          ))}
        </Select>

        <Select
          value={panchayatId}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option?.children;
            return String(children).toLowerCase().includes(input.toLowerCase());
          }}
          placeholder="Select Panchayat"
          style={{
            minWidth: "150px",
            flex: "1",
            marginBottom: "10px",
            border: "1px solid grey",
            borderRadius: 5,
          }}
          onChange={OnPanchayatSelect}
        >
          <Option key={827272} value="" disabled>
            Select Panchayat
          </Option>
          {panchayatList?.map((item) => (
            <Option key={item?._id} value={item?._id}>
              {item.panchayatName}
            </Option>
          ))}
        </Select>

        <Select
          value={boothId}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option?.children;
            return String(children).toLowerCase().includes(input.toLowerCase());
          }}
          placeholder="Select Booth"
          style={{
            minWidth: "150px",
            flex: "1",
            marginBottom: "10px",
            border: "1px solid grey",
            borderRadius: 5,
          }}
          onChange={OnBoothSelect}
        >
          <Option key={827272} value="" disabled>
            Select Booth
          </Option>
          {boothList?.map((item) => (
            <Option key={item?._id} value={item?._id}>
              {item.boothNumber}
            </Option>
          ))}
        </Select>
      </div>

      <Dragger
        name="file"
        accept=".csv, .xlsx"
        customRequest={({ onSuccess }) => onSuccess("ok")}
        onChange={handleFileUpload}
        disabled={!assemblyId}
        multiple={false}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
      </Dragger>

      {data.length > 0 && (
        <>
          <CustomTable
            dataSource={data}
            columns={columns}
            rowKey="key"
            pagination={false}
            bordered
            size="middle"
            style={{
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              backgroundColor: "#fff",
              width: "100%",
              overflowX: "auto",
            }}
            scroll={{ x: 800 }}
          />
          <Button
            type="primary"
            style={{ marginTop: 20 }}
            onClick={handleSaveAll}
          >
            Save All Changes
          </Button>
        </>
      )}
      <Modal
        title=" "
        open={isModalVisible}
        onCancel={hideModal}
        footer={[
          <Button key="cancel" onClick={hideModal}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  handleAddVoter(values);
                })
                .catch((info) => {
                  console.log("Validation Failed:", info);
                });
            }}
          >
            Save
          </Button>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleAddVoter}
          style={{
            maxWidth: 900,
            margin: "0 auto",
            padding: "2rem",
            backgroundColor: "#f7f7f7",
            borderRadius: "8px",
          }}
        >
          <h2 style={{ textAlign: "center", color: "#1890ff" }}>
            Voter Information
          </h2>

          {/* Constituency Selection */}
          <Form.Item required>
            <Row gutter={16}>
              <Col span={12}>
                <Select
                  value={constituencyId}
                  showSearch
                  placeholder="Select Constituency"
                  onChange={OnConstituencySelect}
                  style={{ width: "100%" }}
                >
                  <Option key={827272} value="" disabled>
                    Select Parliament
                  </Option>
                  {constituencyList?.map((item) => (
                    <Option key={item?._id} value={item?._id}>
                      {item?.constituencyName}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={12}>
                <Select
                  value={assemblyId}
                  showSearch
                  placeholder="Select Assembly"
                  onChange={OnAssemblySelect}
                  disabled={!constituencyId}
                  style={{ width: "100%" }}
                >
                  <Option key={827272} value="" disabled>
                    Select Assembly
                  </Option>
                  {assemblyList?.map((item) => (
                    <Option key={item?._id} value={item?._id}>
                      {item?.assemblyName}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item required>
            <Row gutter={16}>
              <Col span={12}>
                <Select
                  value={panchayatId}
                  showSearch
                  placeholder="Select Panchayat"
                  onChange={OnPanchayatSelect}
                  disabled={!assemblyId}
                  style={{ width: "100%" }}
                >
                  <Option key={827272} value="" disabled>
                    Select Panchayat
                  </Option>
                  {panchayatList?.map((item) => (
                    <Option key={item?._id} value={item?._id}>
                      {item?.panchayatName}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col span={12}>
                <Select
                  value={boothId}
                  showSearch
                  placeholder="Select Booth"
                  onChange={OnBoothSelect}
                  disabled={!panchayatId}
                  style={{ width: "100%" }}
                >
                  <Option key={827272} value="" disabled>
                    Select Booth
                  </Option>
                  {boothList?.map((item) => (
                    <Option key={item?._id} value={item?._id}>
                      {item?.boothNumber}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Form.Item>

          {/* Personal Information */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="EPIC No"
                name="epicNo"
                rules={[
                  { required: true, message: "EPIC number is required!" },
                ]}
              >
                <Input placeholder="Enter EPIC number" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={[
                  { required: true, message: "First name is required!" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter first name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Middle Name"
                name="middleName"
                rules={[
                  { required: true, message: "Middle name is required!" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter middle name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Last Name"
                name="lastName"
                rules={[
                  { required: true, message: "Last name is required!" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter last name" />
              </Form.Item>
            </Col>
          </Row>

          {/* Additional Fields */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Section Name"
                name="sectionName"
                rules={[
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter section name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Section Number"
                name="sectionNumber"
                rules={[
                  { pattern: /^[0-9]+$/, message: "Only numbers are allowed" },
                ]}
              >
                <Input placeholder="Enter section number" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="SL No in Part" name="slNoInPart">
                <Input placeholder="Enter SL number in part" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="House Number" name="houseNumber">
                <Input placeholder="Enter house number" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Family Code" name="familyCode">
                <Input placeholder="Enter family code" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Relation Type" name="relationType">
                <Input placeholder="Enter relation type" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Relation First Name"
                name="relationFirstName"
                rules={[
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter relation first name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Relation Last Name"
                name="relationLastName"
                rules={[
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter relation last name" />
              </Form.Item>
            </Col>
          </Row>

          {/* Gender, Age, Date of Birth */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Gender" name="gender">
                <Select placeholder="Select gender">
                  <Option value="male">Male</Option>
                  <Option value="female">Female</Option>
                  <Option value="other">Other</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Age"
                name="age"
                rules={[
                  { pattern: /^[0-9]+$/, message: "Only numbers are allowed" },
                ]}
              >
                <Input type="number" placeholder="Enter age" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Date of Birth" name="dob">
                <Input type="date" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Mobile Number"
                name="mobileNumber"
                rules={[
                  { pattern: /^[0-9]+$/, message: "Only numbers are allowed" },
                ]}
              >
                <Input
                  type="tel"
                  placeholder="Enter mobile number"
                  maxLength={10}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Switch Fields */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Head of the Family"
                name="headOfFamily"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Stay Outside"
                name="stayOutside"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Relation with Sangha Pariwar"
                name="relationwithsanghapariwar"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Influencer"
                name="influencer"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          {/* Party, Education, Email */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Party Supported" name="partySupported">
                <Input placeholder="Enter party supported" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Education" name="education">
                <Input placeholder="Enter education" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input placeholder="Enter email" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Caste"
                name="caste"
                rules={[
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter caste" />
              </Form.Item>
            </Col>
          </Row>

          {/* Sub Caste, Religion, Remark */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Sub Caste"
                name="subCaste"
                rules={[
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter sub caste" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Religion"
                name="religion"
                rules={[
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Only letters and spaces are allowed",
                  },
                ]}
              >
                <Input placeholder="Enter religion" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Remark" name="remark">
                <Input placeholder="Enter remark" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="WhatsApp Number"
                name="whatsappNumber"
                rules={[
                  { pattern: /^[0-9]+$/, message: "Only numbers are allowed" },
                ]}
              >
                <Input
                  type="tel"
                  placeholder="Enter WhatsApp number"
                  maxLength={10}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default AddVoters;
